import React, { FunctionComponent } from 'react';
import { IconButton, MenuItem } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Action } from '../../styles';
import editPng from '../../../../../assets/images/edit.png';

type UpdateButtonProps = {
    id: number;
    setChange: (x: boolean) => void;
};

function cmp(prev: UpdateButtonProps, next: UpdateButtonProps): boolean {
    return prev.id === next.id;
}

const UpdateButton: FunctionComponent<UpdateButtonProps> = React.memo(({ id, setChange }) => {
    const history = useHistory();
    return <MenuItem onClick={() => { setChange(true); history.push({ pathname: `users`, search: `?id=${id}`, state: { prevPath: window.location.href } }); }} >
        <Action bg={'#919191'}>
            <IconButton>
                <img src={editPng} alt="icon" />
            </IconButton>
        </Action>
    </MenuItem>;
}, cmp);

export default UpdateButton;